
import {createSlice} from "@reduxjs/toolkit";

export const contractDataPointValueSlice = createSlice({
    name: 'contractDataPointValueSlc',
    initialState: {value: {id: 0, contractDataPointId: null, contractDataPointValueFilterId: null,
            ordinalNumber: null, iterationNumber: null,
            extendInd: false, value: null, expression: null, expressionDescription: null,
            expressionTranslation: null, sourceContractDataPointValueId: null,
            origin: null, status: null, mockValue: null, cycleNumber: null,
            createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
        defaultValue: null}, randomized: false,
        cdpvDrawerState: false, cdpvDrawerMode: null, cdpvGridRefresh: false, cdpvCount: 0,cdpvGridState: false, cdpvFormState: false,
        cdpvDrawerContext: "none", cdpvViewValueOnly: null},
    reducers:

{
    changeContractDataPointValue: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDataPointValue } = contractDataPointValueSlice.actions;

export default  contractDataPointValueSlice.reducer ;
